import { Button as AntdButton, ButtonProps as AntdButtonProps } from "antd";
import { LoadingMediumIcon } from "@/base/static/index";
import { CMP_PREFIX } from "@/base/constant";

export interface ButtonProps extends AntdButtonProps {}

export const buttonPrefixCls = `${CMP_PREFIX}-btn`;

export const Button = ({ children, size, loading, ...props }: ButtonProps) => {
  return (
    <AntdButton
      {...props}
      size={size}
      loading={
        loading && {
          icon: <LoadingMediumIcon spin />,
        }
      }
    >
      {children && (
        <span className={`${buttonPrefixCls}-content`}>{children}</span>
      )}
    </AntdButton>
  );
};
